/** @module gridData */

export const voidLavaSquares = [
  "0_8",
  "0_9",
  "0_10",
  "1_10",
  "6_0",
  "6_1",
  "6_2"
];

export const gateSquares = ["0_0", "0_5", "1_9", "4_0", "4_10", "6_6", "6_8"];
